import React, { useEffect, useState, useRef } from 'react';
import synergy1 from '../../assets/images/brand/brand_ synergy_1.png';
import synergy2 from '../../assets/images/brand/brand_ synergy_2.png';
import synergy3 from '../../assets/images/brand/brand_ synergy_3.png';

const synergyData = [
  {
    title: '국내 유일<br />AR 렌즈 체험 플랫폼',
    desc: '고객이 앱에서 직접 눈에 렌즈를 착용해보며<br />제품을 실감나게 경험하여 구매 전환율 향상',
    image: synergy1
  },
  {
    title: 'K-POP 아이돌 IP 활용<br />마케팅 시너지',
    desc: '아이돌 모델 브랜드와의 동시 노출로<br />단독 브랜드 대비 압도적인 관심과 유입 실현',
    image: synergy2
  },
  {
    title: '인플루언서 기반<br />실구매 연결 콘텐츠 기획',
    desc: '인기 인플루언서 협업 콘텐츠를 공동 기획하여<br />실구매로 이어지는 캠페인 구성 가능',
    image: synergy3
  },
];

const BrandSynergy = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        } else {
          setIsVisible(false);
        }
      },
      {
        threshold: window.innerWidth < 768 ? 0.05 : 0.2,
        rootMargin: '-50px'
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    const handleResize = () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
        observer.disconnect();
        
        const newObserver = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              setIsVisible(true);
            } else {
              setIsVisible(false);
            }
          },
          {
            threshold: window.innerWidth < 768 ? 0.05 : 0.2,
            rootMargin: '-50px'
          }
        );
        
        newObserver.observe(sectionRef.current);
      }
    };

    window.addEventListener('resize', handleResize);

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <section ref={sectionRef} className="w-full bg-[#FEF1F9] flex items-center justify-center py-[80px] md:py-[100px]">
      <div className={`flex flex-col items-center transition-all duration-[2000ms] [transition-timing-function:cubic-bezier(0.4,0,0.2,1)] ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
        <h2 
          className="text-[24px] md:text-[40px] text-black leading-[140%] font-bold mb-8 text-center">
            {/* 브랜드 매출을 높이는 콘텐츠 시너지 */}
          <span className="md:hidden">브랜드 매출을 높이는<br/>콘텐츠 시너지</span>
          <span className="hidden md:inline">브랜드 매출을 높이는 콘텐츠 시너지</span>
        </h2>
        <div className="flex flex-col md:flex-row gap-[80px] md:gap-[60px] w-full justify-center items-center mt-[20px] md:mt-[40px] pb-[40px] md:pb-[40px]">
          {synergyData.map((item, idx) => (
            <div key={idx} className="w-[360px] md:w-[400px] h-auto flex flex-col items-center">
              <div className="w-[270px] h-[360px] md:w-[300px] md:h-[400px] mb-4">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover"
                />
              </div>
              <h3
                className="font-pretendard font-semibold text-[20px] md:text-[24px] text-black leading-[140%] mb-2 text-center mt-[20px]"
                dangerouslySetInnerHTML={{ __html: item.title }}
              />
              <p
                className="font-pretendard font-medium text-[16px] md:text-[20px] text-[#333333] leading-[140%] text-center mt-[16px] font-normal"
                dangerouslySetInnerHTML={{ __html: item.desc }}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BrandSynergy; 